import { produce } from 'immer';
import type { StoreApi } from 'zustand';
import type { Layer } from '@/lib/db-row-types';
import type { MapPanelsUIState } from './mapPanelsUI.slice';

// Layers slice
export type LayersState = {
  layers: Record<string, Layer>;
  layersLoading: boolean;
  setLayers: (layers: Layer[]) => void;
  setLayersLoading: (loading: boolean) => void;
  clearLayers: () => void;
  addLayer: (layer: Layer) => void;
  updateLayer: (layer: Partial<Layer> & { id: string }) => void;
  removeLayer: (id: string) => void;
};

export const createLayersSlice = (set: StoreApi<any>['setState']) => ({
  layers: {},
  layersLoading: false,
  setLayers: (layers: Layer[]) =>
    set(
      produce((draft: LayersState) => {
        draft.layers = Object.fromEntries(layers.map(l => [l.id, l]));
        draft.layersLoading = false;
      })
    ),
  setLayersLoading: (loading: boolean) =>
    set(
      produce((draft: LayersState) => {
        draft.layersLoading = loading;
      })
    ),
  clearLayers: () =>
    set(
      produce((draft: LayersState) => {
        draft.layers = {};
        draft.layersLoading = false;
      })
    ),
  addLayer: (layer: Layer) =>
    set(
      produce((draft: LayersState) => {
        // This will add a new layer or overwrite an existing one.
        draft.layers[layer.id] = layer;
      })
    ),
  updateLayer: (layer: Partial<Layer> & { id: string }) =>
    set(
      produce((draft: LayersState) => {
        const existing = draft.layers[layer.id];
        if (existing) {
          draft.layers[layer.id] = { ...existing, ...layer };
        }
      })
    ),
  removeLayer: (id: string) =>
    set(
      produce((draft: LayersState & MapPanelsUIState) => {
        delete draft.layers[id];
        if (draft.currentAgentLayerId === id) {
          draft.agentPanelOpen = false;
          draft.currentAgentLayerId = null;
          draft.agentPanelPendingPrompt = null;
        }
      })
    ),
});
